// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__kYzex","colMin":"styles_colMin__13XBJ"};